import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useAuth } from "./AuthContext";

const CartContext = createContext();

const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const prevUserRef = useRef(user);

  const [cart, setCart] = useState(() => {
    const storagedCart = localStorage.getItem("@guruseg:cart");

    if (storagedCart) {
      return JSON.parse(storagedCart);
    }

    return {
      servicesOrder: [],
      nameOS: "",
      collaborators: 0,
      sector: "",
      company: null,
      observation: "",
      isUrgent: false,
      reminder: false,
      code: "",
      discount: null,
      type: "elaboracao",
    };
  });

  const clearCart = useCallback(() => {
    const emptyCart = {
      servicesOrder: [],
      nameOS: "",
      collaborators: 0,
      sector: "",
      company: null,
      observation: "",
      isUrgent: false,
      reminder: true,
      code: "",
      discount: null,
      type: "elaboracao",
    };
    setCart(emptyCart);
    localStorage.removeItem("@guruseg:cart");
  }, []);

  useEffect(() => {
    // Clear cart when user changes (login/logout)
    if (prevUserRef.current?.id !== user?.id) {
      clearCart();
    }
    prevUserRef.current = user;
  }, [user, clearCart]);

  useEffect(() => {
    localStorage.setItem("@guruseg:cart", JSON.stringify(cart));
  }, [cart]);

  const updateCart = useCallback((newData) => {
    setCart((oldCart) => ({ ...oldCart, ...newData }));
  }, []);

  const getCartTotals = useCallback(() => {
    const itemsCount =
      cart.servicesOrder.reduce((total, item) => {
        return total + item.amount;
      }, 0) + (cart.isUrgent ? 1 : 0);

    const subtotal =
      cart.servicesOrder.reduce((total, item) => {
        return total + item.value * item.amount;
      }, 0) + (cart.isUrgent ? 147 : 0);

    let discountValue = 0;
    if (cart.discount) {
      discountValue =
        cart.discount.type === "FIXED"
          ? cart.discount.value
          : subtotal * (cart.discount.value / 100);
    }

    const totalValue = subtotal - discountValue;

    return {
      itemsCount,
      subtotal,
      discountValue,
      totalValue: totalValue > 0 ? totalValue : 0,
    };
  }, [cart]);

  return (
    <CartContext.Provider
      value={{ cart, updateCart, clearCart, getCartTotals }}
    >
      {children}
    </CartContext.Provider>
  );
};

function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used with a CartProvider");
  }
  return context;
}

export { CartProvider, useCart };
